var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollaricon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.378 8.826C7.378 9.274 7.266 9.70333 7.042 10.114C6.818 10.5153 6.48667 10.8513 6.048 11.122C5.61867 11.3927 5.10067 11.5467 4.494 11.584V12.718H3.738V11.584C2.88867 11.5093 2.198 11.2387 1.666 10.772C1.134 10.296 0.863333 9.694 0.854 8.966H2.212C2.24933 9.358 2.394 9.69867 2.646 9.988C2.90733 10.2773 3.27133 10.4593 3.738 10.534V7.034C3.11267 6.87533 2.60867 6.712 2.226 6.544C1.84333 6.376 1.51667 6.11467 1.246 5.76C0.975333 5.40533 0.84 4.92933 0.84 4.332C0.84 3.576 1.10133 2.95067 1.624 2.456C2.156 1.96133 2.86067 1.686 3.738 1.63V0.467999H4.494V1.63C5.28733 1.69533 5.92667 1.952 6.412 2.4C6.89733 2.83867 7.17733 3.41267 7.252 4.122H5.894C5.84733 3.79533 5.70267 3.50133 5.46 3.24C5.21733 2.96933 4.89533 2.792 4.494 2.708V6.124C5.11 6.28267 5.60933 6.446 5.992 6.614C6.384 6.77267 6.71067 7.02933 6.972 7.384C7.24267 7.73867 7.378 8.21933 7.378 8.826ZM2.142 4.262C2.142 4.71933 2.27733 5.06933 2.548 5.312C2.81867 5.55467 3.21533 5.75533 3.738 5.914V2.68C3.25267 2.72667 2.86533 2.88533 2.576 3.156C2.28667 3.41733 2.142 3.786 2.142 4.262ZM4.494 10.548C4.998 10.492 5.39 10.31 5.67 10.002C5.95933 9.694 6.104 9.32533 6.104 8.896C6.104 8.43867 5.964 8.08867 5.684 7.846C5.404 7.594 5.00733 7.39333 4.494 7.244V10.548Z",
    fill: "#868687"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollaricon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollaricon.721aabfdedece22b2f10e91e93ecdb26.svg";